import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationContext } from '../../../hoc/Localization';
import Button from '../../Button';
import styles from './styles.less';

const Join = ({ text, link, forumLink }) => {
  const { t, locale } = React.useContext(LocalizationContext);

  return (
    <div className={styles.join}>
      <h2>{t('landing.join.title')}</h2>
      <h3>{text}</h3>
      <Button version="large" type="secondary">
        <a href={link} target="_blank" rel="noopener noreferrer">
          {t('landing.join.button')}
        </a>
      </Button>
      {locale === 'hy' && forumLink && (
        <Button version="large" type="secondary">
          <a
            className={`${styles.forum}`}
            href={forumLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('header.menu.forum')}
          </a>
        </Button>
      )}
    </div>
  );
};

Join.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  forumLink: PropTypes.string.isRequired,
};

export default Join;
